import React from "react";
import Grid from '@mui/material/Grid';
import SmallTable from "./SmallTable";

const SmallTableViews = (props) => {
    return (
        <Grid container justify="right" spacing={2}>
            <Grid item xs>
                <SmallTable
                    title={"Experiments per Group Owner"} 
                    columnsData={props.columnsDataOwner}
                    loadTableData={props.loadTableData}
                    statusContents={props.statusContents}
                    getCsvData={props.getCsvOwnerData}
                />
            </Grid>

            <Grid item xs>
                <SmallTable
                    title={"Experiments per Project"} 
                    columnsData={props.columnsDataProject}
                    loadTableData={props.loadTableData}
                    statusContents={props.statusContents}
                    getCsvData={props.getCsvProjectData}
                />
            </Grid>
                
            <Grid item xs>
                <SmallTable
                    title={"Experiments per Library Strategy"} 
                    columnsData={props.columnsDataLibraryStrategy}
                    loadTableData={props.loadTableData}
                    statusContents={props.statusContents}
                    getCsvData={props.getCsvStrategyData}
                />
            </Grid>
        </Grid>
    );
}

export default SmallTableViews;